import styled from 'styled-components'

export const ChartWrapper = styled.div`
  /* max-height: 500px; */
`
